import React from "react";
import { Row, Col, Breadcrumb, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SEO from "../../components/SEO";

const Coinpolicy = () => {
    const navigate = useNavigate();
    const goBack = () => {
        navigate('/');
    };
    return (
        <>
            <SEO
                title="Coin Policy"
                description="Read Shaadi Material's Coin Policy and learn how we use Coins, analytics, advertising, and preference settings."
                canonical="https://shaadimaterial.com/coin-policy"
            />
            <Container className="py-5 policypage">
                <Row className="breadcrumb_part mb-5">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={goBack}>Home</Breadcrumb.Item>
                        <Breadcrumb.Item active>Coin Policy</Breadcrumb.Item>
                    </Breadcrumb>
                </Row>
                <Row>
                    <Col md={12}>
                        <h2>Coin Policy</h2>
                        <h5 className="my-4 d-block"># Terms &amp; Conditions — Subscription, Coins &amp; Downloads</h5>
                        <h4>1. Subscription Plans</h4>
                        <p>Shaddi Material offers two subscription plans:</p>
                        <ul>
                            <li><b>Monthly Plan - </b> billed every month, granting access to the platform and a coin balance as described.</li>
                            <li><b>Annual Plan - </b> billed once a year, granting access to the platform and a coin balance as described.</li>
                        </ul>
                        <p>
                            Subscription fees are non-refundable except as required by applicable law or as otherwise stated in
                            our Refund Policy.
                        </p>
                        <h4>2. Coin Balance</h4>
                        <p>
                            Upon subscribing to either the Monthly or Annual plan, a fixed number of coins will be credited to
                            your account. This coin balance is used to download content from the platform, including
                            backdrops, caricatures, decor, elements, and flora &amp; fauna assets, in PNG or PSD format.
                        </p>
                        <p>
                            i) Each downloadable asset has a coin value assigned to it, displayed at the time of download. <br/>
                            ii) Coins are deducted from your account balance every time you initiate a download, regardless of file format (PNG or PSD).<br/>
                            iii) Coin values may vary by asset, category, or file type, at our discretion.
                        </p>
                        <h4>3. Repeat Downloads</h4>
                        <p>
                            Downloading an asset does <b>**not**</b> make it free for future downloads. Each time you click
                            download on an asset — whether it is the same file downloaded previously or a new one — the
                            applicable coin amount will be deducted from your account balance. Your download history does
                            not entitle you to unlimited or free re-downloads of previously downloaded content.
                        </p>
                        <h4>4. Coin Balance Renewal, Rollover &amp; Top-Ups</h4>
                        <ul>
                            <li>
                                Coins allotted under the Monthly Plan are credited at the start of each billing cycle. **Unused
                                coins roll over to the next billing cycle** as long as your subscription remains active — they do not
                                expire at the end of the month.
                            </li>
                            <li>
                                Coins allotted under the Annual Plan are credited [specify: upfront for the full year / in monthly
                                instalments across the year]. [Specify rollover/expiry policy for the Annual Plan.]
                            </li>
                            <li>
                                If your coin balance runs out before your current billing cycle ends, you have the option to
                                **purchase additional coins** at any time, without needing to wait for your next renewal. These
                                purchased coins are added on top of your existing balance and are subject to the same rollover
                                treatment described above.
                            </li>
                            <li>
                                Rollover coins remain tied to an active subscription. If your subscription lapses or is cancelled,
                                any remaining coin balance (including rolled-over coins) will be handled as described in the
                                Cancellation and Termination sections of these Terms.
                            </li>
                            <li>
                                Once your coin balance is exhausted and you choose not to purchase additional coins, you will
                                need to wait for your next billing cycle&#39;s credit or upgrade your plan to continue downloading.
                            </li>
                        </ul>
                        <h4>5. Device-Specific Downloads &amp; Account Access</h4>
                        <ul>
                            <li>
                                Downloaded files are saved locally to the device on which the download was initiated. They are
                                **not** synced, backed up, or made available across other devices, even when logging into the
                                same account.
                            </li>
                            <li>
                                If you log into your account on a different device, your previous download history will be visible for
                                reference, but the actual downloaded files will **not** be automatically available on that device. To
                                access a file on a different device, it must be downloaded again, and the applicable coins will be
                                deducted accordingly.
                            </li>
                            <li>
                                Sharing your login credentials (username/email and password) with any other individual does not
                                grant that individual access to files you have previously downloaded on your own device. Any
                                downloads made through your account — by you or anyone using your credentials — will deduct
                                coins from your account balance.
                            </li>
                            <li>
                                Once a file has been downloaded and saved to a device, any further sharing, transfer, or
                                distribution of that file from the device is outside the scope of the platform and is the sole
                                responsibility of the account holder, subject to our [Usage Rights/License Terms].
                            </li>
                            <li>
                                We are not responsible for unauthorized access to your account resulting from shared credentials,
                                including any resulting coin deductions from downloads made by third parties using your login.
                            </li>
                        </ul>
                        <h4>6. Account Responsibility</h4>
                        <p>
                            You are responsible for maintaining the confidentiality of your account login credentials and for all
                            activity that occurs under your account, including coin deductions resulting from downloads made
                            through your account, whether by you or by anyone with whom you have shared access.
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
        
export default Coinpolicy;